<template>
  <div class="contranter">
    <Topbar :tab_index="tab_index" :had_login="had_login"></Topbar>
    <div class="box-co" v-if="show_example">
      <img heigt="auto" class="detail-img" src="../assets/expm.png" />
      <img class="close-img" @click="closeExample" src="../assets/close-btn.png" />
    </div>
    <div id="main" v-if="!show_example">
      <div class="banner">
        <img class="banner-s" src="../assets/banner2.png" />
        <!-- <img src="../assets/banner-text.png" class="banner-float" /> -->
        <div class="login" v-if="!had_login">
          <div class="title">作品上传登录</div>
          <div class="inp_box">
            <div class="label">手机号：</div>
            <div class="mobile_inp">
              <input type="text" v-model="mobile" placeholder="请输入..." maxlength="11" class="mobile mobileInp" />
              <div class="getCode" @click="sendCheckCode">{{ code_tip }}</div>
            </div>
          </div>
          <div class="inp_box">
            <div class="label">验证码：</div>
            <input type="text" v-model="code_num" placeholder="请输入..." class="code inp" />
          </div>
          <div class="loginBtn" @click="loginIn">登录</div>
          <div class="notice">
            未注册用户请先扫码登录“雅生设计之家”微信小程序， 注册成为会员后再进行手机号登录
          </div>
          <img src="../assets/wxCode.png" class="wxCode" />
        </div>
        <div class="done" v-if="had_login && !done">
          <img src="../assets/done.png" />
          <h2>登录成功</h2>
          <p>
            欢迎您，参加第五届雅生室内设计大赛。<br />
            本次大赛我们将为您提供AXOR产品资料，<br />
            您可以根据设计需要使用我们的产品。
          </p>
          <div class="btns">
            <div class="btn" @click="goDownload">前往获取</div>
            <div class="btn btn-normal" @click="done = true">我知道了</div>
          </div>
        </div>

        <div class="upload" v-if="had_login && done">
          <div class="upload-title">AXOR室内设计大赛</div>
          <div class="upload-container">
            <div class="upload-box">
              <div class="upload-label">作品名称：</div>
              <div class="upload-content">
                <input type="text" v-model="works_title" class="op_name" placeholder="请输入" maxlength="20" />
                <div class="num">{{ works_title.length }}/20</div>
              </div>
            </div>
            <div class="upload-box">
              <div class="upload-label">作品描述：</div>
              <div class="upload-content">
                <textarea class="op_desc_txt" v-model="works_detail" maxlength="500"></textarea>
                <div class="num desc_num">{{ works_detail.length }}/500</div>
              </div>
            </div>
            <div class="upload-box">
              <div class="upload-label">上传图片：</div>
              <div class="upload-content">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false" :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :on-remove="handleImgRemove" multiple accept="image/jpg,image/jpeg,image/png" :http-request="uploadHttpRequestImg">
                  <img class="upload-button" src="../assets/add-box.png" />
                </el-upload>
                <div class="upload-preview-list">
                  <div v-for="(img, index) in imgList" :key="index" class="upload-preview-item">
                    <img :src="img.url" class="upload-thumbnail" />
                    <span class="upload-delete" @click="handleImgRemove(img)">X</span>
                  </div>
                </div>
                <div class="upload-requirement" @click="showRequirement">
                  上传要求
                </div>
              </div>
            </div>
            <div class="upload-box">
              <div class="upload-label">上传作品：</div>
              <div class="upload-content">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false" :on-success="handlePdfSuccess" :before-upload="beforePdfUpload" :on-remove="handlePdfRemove" accept=".pdf" :http-request="uploadHttpRequestPdf">
                  <img class="upload-button" src="../assets/add-box.png" />
                </el-upload>
                <div class="upload-preview-list">
                  <div v-for="(file, index) in fileList" :key="index" class="upload-preview-item">
                    <img src="../assets/pdf-icon.png" class="upload-thumbnail pdf-thumbnail" />
                    <span class="file-name">{{ file.name }}</span>
                    <span class="upload-delete" @click="handlePdfRemove(file)">X</span>
                  </div>
                </div>
                <div class="upload-requirement" @click="showMod">上传要求</div>
              </div>
            </div>
            <div class="upload-box">
              <div class="upload-label">投递类别：</div>
              <div class="upload-content">
                <div class="upload-select">
                  <select name="" v-model="dream_prize" placeholder="请选择">
                    <option>住宅类</option>
                    <option>酒店及公共空间类</option>
                    <option>厨卫空间类</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="upload-box">
              <div class="upload-label">情况告知：</div>
              <div class="upload-content">
                <div class="upload-select">
                  <select name="" v-model="work_situation" placeholder="请选择">
                    <option value="1">作品已（将） 另参赛，赛会未公布得奖名单</option>
                    <option value="2">作品已（将）另参赛，已公布获奖名单</option>
                    <option value="3">作品曾（将）公开发表</option>
                    <option value="4">作品未曾参赛和公开发表</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="upload-box" v-if="work_situation == 2">
              <div class="upload-label">获奖情况：</div>
              <div class="upload-content">
                <input type="text" placeholder="请填写" v-model="award_record" class="op_name" maxlength="20" />
              </div>
            </div>
            <div class="upload-box" v-if="work_situation == 3">
              <div class="upload-label">发表平台：</div>
              <div class="upload-content">
                <input type="text" placeholder="请填写" v-model="publish_platform" class="op_name" maxlength="20" />
              </div>
            </div>
            <div class="upload_btn" @click="submit">确认上传</div>
            <div class="agree">
              <div class="select-box" @click="showRule">
                <img v-if="checked_pro" src="../assets/select.png" class="select-icon" />
              </div>
              <div class="agree-txt">我已阅读并同意<span class="agrement" @click="showRule">隐私协议</span></div>
            </div>
          </div>
        </div>
        <div class="rules rules-box" v-if="show_rule">
          <div class="close" @click="closeRule"></div>
          <div class="rule-title">隐私协议</div>
          <vue-custom-scrollbar class="rule-content" :settings="{ suppressScrollX: true, wheelPropagation: false }" @ps-y-reach-end="scrollEnd">
            <h2>一. 参赛声明</h2>
            <p>
              1. 本人保证保护因参赛或在参赛过程中使用汉斯格雅集团提供的3D模型文件及相关文件（以下称“汉斯格雅文件”）的知识产权或其他相关的权利，包括但不限于不将汉斯格雅文件用于本参赛之外的用途。
            </p>
            <p>2. 本人保证作品为自行创作，具有原创性。</p>
            <p>3. 本人保证拥有作品的全部著作权及其相关财产权利。</p>
            <p>
              4. 本人已了解并同意2026年雅生室内设计奖的竞赛办法、各项规定和注意事项。
            </p>
            <p>
              5. 本人保证作品所有概念、文字、图案、表格、照片、影片、语音、音乐、动画等各种内容及所使用的程序不存在仿冒、抄袭或其他侵害他人著作权等知识产权。
            </p>
            <p>6.本人保证已如实告知参赛作品的使用情况。</p>
            <h2>二. 著作权授权</h2>
            <p>
              1. 本人同意作品授权予2026年雅生室内设计奖的主办单位上海汉斯格雅国际贸易有限公司（以下称“主办单位”）作下述之利用：
            </p>
            <p>1) 配合营销宣传纳入数据库或其他存储路径。</p>
            <p>2) 以纸本或数字等多种方式出版。</p>
            <p>3) 运用至品牌线上、线下各种渠道之推广宣传。</p>
            <p>4) 进行数字化典藏、重制、透过网络公开传输、打印、浏览等用。</p>
            <p>5) 【其他】</p>
            <p>
              2. 本人保证拥有将作品授予主办单位做上述利用的权利，并保证作品不会侵犯任何第三方包括但不限于著作权、肖像权等任何权利，不存在现时及潜在纠纷。
            </p>
            <p>3. 本人同意在签署本书当日，主办单位即有权对作品做上述利用。</p>
            <p>
              4. 作品若为二人以上共同创作，有全体作者签署。若非全体作者签署时，则主办单位可以认为共同著作人同意授权本人代为同意签署本书。
            </p>
            <h2>三. 法律责任</h2>
            <p>
              若本人违反本书下的条款，主办单位有权取消本人参赛资格。若因本人的违反造成主办单位损失的，本人承担全部责任。主办单位受让上述权利后根据法律法规承担责任的，有权向本人追偿。
            </p>
          </vue-custom-scrollbar>
          <div :class="{ upload_btn: true, disabled: cnt > 0 || !readDone }" @click="closeRuleAndConfirm">我已阅读并同意以上协议{{ cnt > 0 ? "(" + cnt + ")" : "" }}</div>
        </div>
        <div class="rules" v-if="show_mod">
          <div class="file-requirement">
            <h2>作品要求</h2>
            <p>提交的作品需具有明确的主题与作品介绍，可包含：</p>
            <ul>
              <li>• 作品整体展示</li>
              <li>• 作品特写</li>
              <li>• 作品设计理念等。</li>
            </ul>
            <p>作品需以PDF文件的形式进行提交。</p>
            <p>
              PDF文件，每个项目最多四页，总大小不超过20M， A2大小，所有文字都转换为图片。
            </p>

            <vue-pure-lightbox id="mylightbox" ref="lightbox" :images="samplePics">
              <template v-slot:preview>
                <div class="file-requirement-btn" @click.prevent="showLightbox">
                  查看示例
                </div>
              </template>
            </vue-pure-lightbox>
          </div>
          <!-- <img src="../assets/file-mod.png" class="rules-img" /> -->
          <div class="close" @click="closeMod"></div>
        </div>
        <div class="rules" v-if="show_requirement">
          <div class="img-requirement">
            <h2>图片要求</h2>
            <p class="line"><span class="line-title">数量：</span><span>至少1张，最多5张</span></p>
            <p class="line">
              <span class="line-title">格式：</span><span>JPG，300 dpi，1748 x 2480 px，<br />A5，每个不超过10M。</span>
            </p>
            <br />
            <p>*您所提交的图片也可用于您的出版作品中。</p>
          </div>
          <div class="close" @click="closeRequirement"></div>
        </div>
      </div>
      <img src="../assets/index-desc-2.png" class="index-desc" />
    </div>
    <!-- <lightbox id="mylightbox" ref="lightbox" :images="samplePics" :timeout-duration="5000" /> -->

    <div class="leo-over-bg" v-if="is_uploading">
      <div class="loader-03"></div>
      <div class="up-txt">{{ uploading_text }}</div>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import VuePureLightbox from "vue-pure-lightbox";

import api from "../api/api";
import uploadfileToOss from "../leo.wang.util/ali-oss";

// 包装 uploadfileToOss 为 Promise
function uploadFileAsync(file) {
  return new Promise((resolve, reject) => {
    uploadfileToOss(
      file,
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
import ops from "../leo.wang.util/operator.string";
import Topbar from "../components/Topbar.vue";
import pub from "../common/pub.js";
export default {
  name: "Dashboard",
  components: {
    VuePureLightbox: VuePureLightbox,
    vueCustomScrollbar,
    Topbar: Topbar,
  },
  data() {
    return {
      title: "AXOR室内设计奖",
      tab_index: 0,
      mobile: "",
      lable_send_code: "获取验证码",
      timer: null,
      code_tip: "获取验证码",
      count_down_size: 60,
      count_down: 60,
      code_num: "",
      had_login: false,
      checked_pro: false,

      works_title: "",
      works_detail: "",
      works_pics: "",
      works_file: "",
      dream_prize: "",
      award_record: "",
      work_situation: 0,

      img_files: [],
      pdf_files: "",

      upload_count: "",
      is_uploading: false,
      uploading_text: "",

      show_rule: false,
      u_info: {},

      show_example: false,

      submit_lock: false,

      show_mod: false,
      img_up_tip: "(图片5张，每张不大于15M)",

      readDone: false,

      show_requirement: false,
      samplePics: [require("../assets/sample_00.jpg"), require("../assets/sample_01.jpg"), require("../assets/sample_02.jpg"), require("../assets/sample_03.jpg")],
      award_record: "",
      publish_platform: "",
      imgList: [],
      fileList: [],

      cnt: 10,

      done: false,

      is_loading: false,
    };
  },
  methods: {
    goDownload() {
      this.$router.push("/data");
    },
    showLightbox() {
      this.$refs.lightbox.show();
    },
    showMod() {
      this.show_mod = true;
    },
    closeMod() {
      this.show_mod = false;
    },
    showExample() {
      this.show_example = true;
    },
    closeExample() {
      this.show_example = false;
    },
    showRequirement() {
      this.show_requirement = true;
    },
    closeRequirement() {
      this.show_requirement = false;
    },
    changeType(e) {
      this.dream_prize = e.target.value;
    },
    submit() {
      let that = this;
      let result = true;
      that.imgList.map((e) => {
        if (e.url == null || e.url == "") {
          result = false;
        }
      });
      if (!result) {
        pub.msgTip("请上传作品名称图");
        return false;
      }
      if (!that.works_title) {
        pub.msgTip("请输入作品名称");
        return false;
      }
      if (!that.works_detail) {
        pub.msgTip("请输入作品描述");
        return false;
      }
      if (that.imgList.length == 0) {
        pub.msgTip("请上传作品名称图");
        return false;
      }
      if (that.fileList.length == 0) {
        pub.msgTip("请上传作品PDF");
        return false;
      }
      if (that.work_situation == 0) {
        pub.msgTip("请选择情况告知");
        return false;
      }
      if (that.dream_prize == "") {
        pub.msgTip("请选择投递类别");
        return false;
      }
      if (!that.checked_pro) {
        pub.msgTip("您还没同意协议");
        return false;
      }
      if (that.submit_lock) {
        return;
      }
      that.submit_lock = true;
      api
        .uploadWorks({
          user_phone: that.u_info.user_phone,
          user_name: that.u_info.user_name,
          agent_id: that.u_info.agent_id,
          works_title: that.works_title,
          works_detail: that.works_detail,
          works_pics: that.imgList.map((e) => e.url).join(";"),
          works_file: that.fileList.map((e) => e.url)[0],
          work_situation: that.work_situation,
          dream_prize: that.dream_prize,
          award_record: that.award_record,
          publish_platform: that.publish_platform,
        })
        .then((res) => {
          if (res.data.code == 200) {
            that.submit_lock = false;
            that.imgList = [];
            that.fileList = [];
            that.img_files = [];
            that.pdf_files = "";
            that.works_detail = "";
            that.works_title = "";
            that.dream_prize = "住宅";
            that.work_situation = 0;
            that.award_record = "";
            that.publish_platform = "";
            pub.msgTip("上传成功");
          } else {
            pub.msgTip("上传失败，请联系");
          }
        });
    },
    closeRule() {
      this.show_rule = false;
    },
    closeRuleAndConfirm() {
      this.checked_pro = true;
      this.show_rule = false;
    },
    showRule() {
      let that = this;
      let intv = setInterval(() => {
        that.cnt = that.cnt - 1;
        if (that.cnt == 0) {
          clearInterval(intv);
        }
      }, 1000);
      this.show_rule = true;
    },
    async uploadHttpRequestImg(options) {
      let that = this;
      const file = options.file;

      if (that.imgList.length >= 5) {
        pub.msgTip("总共最多只能选择5张图片");
        options.onError();
        return;
      }

      const loading = that.$loading({
        lock: true,
        text: "图片上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        const res = await uploadFileAsync(file);
        const newFile = { url: res, name: file.name, uid: file.uid };
        that.imgList.push(newFile);
        options.onSuccess(res, file);
      } catch (error) {
        pub.msgTip("图片上传失败");
        options.onError(error);
        loading.close();
      } finally {
        setTimeout(() => {
          loading.close();
        }, 5000);
      }
    },
    handleImgSuccess(response, file, fileList) {
      // imgList is already updated in uploadHttpRequestImg
    },
    beforeImgUpload(file) {
      const isJPGPNG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt10M = file.size / 1024 / 1024 < 10; // 假设单张图片大小限制为10M

      if (!isJPGPNG) {
        pub.msgTip("上传图片只能是 JPG/PNG 格式!");
      }
      if (!isLt10M) {
        pub.msgTip("上传图片大小不能超过 10MB!");
      }
      return isJPGPNG && isLt10M;
    },
    handleImgRemove(file, fileList) {
      this.imgList = this.imgList.filter((item) => item.uid !== file.uid);
    },
    async uploadHttpRequestPdf(options) {
      let that = this;
      const file = options.file;

      if (that.fileList.length >= 1) {
        pub.msgTip("最多只能选择1个pdf文件");
        options.onError();
        return;
      }

      const loading = that.$loading({
        lock: true,
        text: "PDF上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        const res = await uploadFileAsync(file);
        const newFile = { url: res, name: file.name, uid: file.uid };
        that.fileList.push(newFile);
        options.onSuccess(res, file);
        pub.msgTip("PDF上传成功");
      } catch (error) {
        pub.msgTip("PDF上传失败");
        options.onError(error);
      } finally {
        loading.close();
      }
    },
    handlePdfSuccess(response, file, fileList) {
      // fileList is already updated in uploadHttpRequestPdf
    },
    beforePdfUpload(file) {
      const isPDF = file.type === "application/pdf";
      const isLt20M = file.size / 1024 / 1024 < 20; // 假设PDF文件大小限制为20M

      if (!isPDF) {
        pub.msgTip("上传文件只能是 PDF 格式!");
      }
      if (!isLt20M) {
        pub.msgTip("上传文件大小不能超过 20MB!");
      }
      return isPDF && isLt20M;
    },
    handlePdfRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
    },
    addFile(e) {
      let that = this;
      var files = e.target.files;
      that.upload_count = files.length;
      if (that.upload_count > 1) {
        pub.msgTip("最多只能选择1个pdf");
        return false;
      }
      that.uploading_text = "上传中0/" + that.upload_count + "...";
      that.is_uploading = true;
      files.forEach((element) => {
        that.uploadImage(element, that.upload_count, true);
      });
    },
    addImg(e) {
      let that = this;
      var files = e.target.files;
      that.upload_count = files.length;

      if (that.upload_count + that.img_files.length > 5) {
        pub.msgTip("总共最多只能选择5张图片");
        return false;
      }
      that.uploading_text = "上传中0/" + that.upload_count + "...";
      that.is_uploading = true;
      files.forEach((element) => {
        that.uploadImage(element, that.upload_count, false);
      });
    },
    uploadImage(element, upload_count, is_pdf) {
      let that = this;
      uploadfileToOss(
        element,
        (res) => {
          if (is_pdf) {
            that.pdf_files = res;
          } else {
            that.img_files.push(res);
            that.img_up_tip = "已选择" + that.img_files.length + "/5张";
          }
          that.upload_count--;
          that.uploading_text = "上传中" + (upload_count - that.upload_count) + "/" + upload_count + "...";
          if (that.upload_count == 0) {
            that.is_uploading = false;
          }
        },
        (res) => {
          that.is_uploading = false;
          pub.msgTip(res);
        }
      );
    },
    checkPro() {
      this.checked_pro = !this.checked_pro;
    },
    scrollEnd() {
      this.readDone = true;
    },
    loginIn() {
      if (!this.mobile) {
        pub.msgTip("请输入手机号");
        return false;
      }
      if (!this.code_num) {
        pub.msgTip("请输入验证码");
        return false;
      }
      let that = this;
      api
        .userLogin({
          user_phone: that.mobile,
          check_code: that.code_num,
        })
        .then((res) => {
          if (res.data.code == 40000) {
            if (res.data.msg == "验证码有误") {
              pub.msgTip("验证码错误");
            } else {
              pub.msgTip("请现在小程序上报名");
            }
          } else if (res.data.code == 200) {
            that.had_login = true;
            localStorage.setItem("mobile", that.mobile);
            localStorage.setItem("login_time", new Date().getTime());
            that.getMyInfo();
          }
        });
    },
    inputMobile(e) {
      this.mobile = e.detail.value;
    },
    sendCheckCode() {
      if (!this.mobile) {
        pub.msgTip("请输入手机号");
        return false;
      }
      let that = this;
      if (!that.timer) {
        that.count_down = that.count_down_size;
        api
          .sendCheckCode({
            user_phone: that.mobile,
          })
          .then((res) => {
            if (res.data.code == 40000) {
              that.timer = null;
              that.code_tip = that.lable_send_code;
              that.count_down = that.count_down_size;
              pub.msgTip(res.data.msg);
            } else if (res.data.code == 200) {
              that.code_tip = that.count_down + "s";
              this.code_num = res.data.info.code;
              that.timer = setInterval(function() {
                if (that.count_down > 0) {
                  that.count_down--;
                  that.code_tip = that.count_down + "s";
                } else {
                  clearInterval(that.timer);
                  that.timer = null;
                  that.code_tip = that.lable_send_code;
                  that.count_down = that.count_down_size;
                }
              }, 1000);
            }
          });
      }
    },
    naviToDetail(item) {
      // this.$router.push('schedule');
    },

    getMyInfo() {
      let that = this;
      let phone_number = localStorage.getItem("mobile");
      if (phone_number) {
        this.had_login = true;
        api
          .getMyInfo({
            user_phone: ops.encode(phone_number),
          })
          .then((res) => {
            that.u_info = res.data.data.info;
          });
      }
    },
  },
  created() {
    //window.document.title = this.title;
  },
  mounted() {
    this.getMyInfo();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upload-x {
  /* height: 1rem; */
}

.loader-03 {
  top: 50%;
  border: 0.05rem solid currentcolor;
  border-bottom-color: transparent;
  border-radius: 50%;
  animation: 1s loader-03 linear infinite;
  -webkit-animation: 1s loader-03 linear infinite;
  position: relative;
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  color: rgba(255, 255, 255, 0.7);
  vertical-align: middle;
  pointer-events: none;
  margin-top: -100px;
}

@-webkit-keyframes loader-03 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loader-03 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.up-txt {
  position: absolute;
  top: 50%;
  color: #fff;
  text-align: center;
  width: 100%;
  font-size: 0.24rem;
  text-align: center;
  margin-top: 0.4rem;
}

.leo-over-bg {
  position: fixed;
  text-align: center;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.8);
}

.agree-txt span {
  text-decoration: underline;
}

.box-co {
  overflow: hidden;
  background: #bebde4;
  padding-bottom: 2rem;
}

.detail-img {
  display: block;
  width: 50%;
  margin: 0 auto;
}

.close-img {
  position: absolute;
  z-index: 1111;
  top: 1.5rem;
  right: 0.5rem;
  width: 0.31rem;
}

.selectList option {
  font-size: 0.2rem;
}

.img-requirement {
  text-align: center;
  padding: 0.8rem;
  padding-top: 1.2rem;
}

.img-requirement h2 {
  font-size: 0.324rem;
  font-weight: 300;
  margin-bottom: 0.3rem;
}

.img-requirement p {
  font-size: 0.18rem;
  font-weight: 300;
  text-align: left;
  line-height: 0.3rem;
}

.line {
  font-weight: normal;
}

.line span {
  display: inline-flex;
  font-size: 0.18rem;
  width: 2.4rem;
}

.line .line-title {
  width: 0.6rem;
  font-weight: bolder;
}

.file-requirement {
  text-align: center;
  padding: 0.8rem;
  padding-top: 1.2rem;
}

.file-requirement h2 {
  font-size: 0.324rem;
  font-weight: 300;
  margin-bottom: 0.3rem;
}

.file-requirement ul {
  padding-left: 0rem;
  margin-bottom: 0.2rem;
}

.file-requirement ul,
.file-requirement p {
  font-size: 0.18rem;
  font-weight: 300;
  text-align: left;
  line-height: 0.35rem;
}

.file-requirement-btn {
  height: 0.4rem;
  background: #ffffff;
  margin: 0.3rem auto;
  color: #333333;
  font-size: 0.18rem;
  line-height: 0.4rem;
  text-align: center;
  cursor: pointer;
}

.upload {
  text-align: center;
  z-index: 10;
}

.upload-container {
  width: 3.6rem;
  margin: 0 auto;
}

.upload-box {
  display: flex;
  color: #fff;
  font-size: 0.2rem !important;
  margin-bottom: 0.15rem;
}

.upload-label {
  flex: 1 0 1.2rem;
  line-height: 0.4rem;
}

.upload-content {
  flex: 1 0 2.4rem;
  position: relative;
  text-align: left;
}

.op_name {
  width: 2.4rem;
  border: 0.01rem solid #ffffff;
  font-size: 0.2rem;
}

.op_desc_txt {
  width: 2.4rem;
  height: 0.5rem;
  background: transparent;
  border: 0.01rem solid #ffffff;
  padding: 0.1rem 0.1rem 0.2rem 0.1rem;
  color: #ffffff;
  font-size: 0.2rem;
  outline: none;
  text-align: left;
  line-height: 0.3rem;
  resize: none;
}

.num {
  position: absolute;
  right: 0.1rem;
  font-size: 0.14rem;
  line-height: 0.43rem;
  pointer-events: none;
}

.desc_num {
  position: absolute;
  right: 0.1rem;
  bottom: 0rem;
  font-size: 0.14rem;
  line-height: 0.43rem;
  pointer-events: none;
}

.upload-button {
  width: 0.35rem !important;
  height: 0.35rem !important;
}

.done {
  width: 4.62rem;
  height: 7.68rem;
  position: absolute;
  z-index: 20;
  margin-top: 1rem;
  top: 1.16rem;
  left: 2.1rem;
  background: #000;
  color: #fff;
  padding-top: 1rem;
  box-sizing: border-box;
  text-align: center;
}

.done img {
  margin: 0 auto;
}

.done h2 {
  font-size: 0.324rem;
  font-weight: 300;
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
}

.done p {
  width: 75%;
  margin: 0 auto;
  font-size: 0.18rem;
  font-weight: 300;
  line-height: 0.3rem;
}

.done .btns {
  display: flex;
  padding: 0 0.5rem;
}

.done .btn {
  width: 1.5rem;
  height: 0.4rem;
  background: #ffffff;
  margin: 0.3rem auto;
  color: #333333;
  font-size: 0.18rem;
  line-height: 0.4rem;
  text-align: center;
  cursor: pointer;
  border: 1px solid #fff;
}

.done .btn-normal {
  color: #fff;
  background-color: #000;
  border: 1px solid #fff;
}

.upload-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.1rem;
  margin-top: 0.1rem;
}

.upload-preview-item {
  position: relative;
  width: 0.35rem;
  height: 0.35rem;
  border: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.upload-thumbnail {
  max-width: 100%;
  max-height: 100%;
  display: block;
}

.pdf-thumbnail {
  width: 0.5rem;
  height: 0.5rem;
}

.file-name {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 0.12rem;
  text-align: center;
  padding: 0.02rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.upload-delete {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(255, 0, 0, 0.7);
  color: #fff;
  width: 0.2rem;
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.14rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue